import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useIsEmbed } from '@aftersale-next/atoms';
import { PoweredByLogo } from '@aftersale-next/ui';
import { Flex, Box } from '@chakra-ui/layout';
export var PageContent = function PageContent(_ref) {
  var children = _ref.children;

  var _useIsEmbed = useIsEmbed(),
      _useIsEmbed2 = _slicedToArray(_useIsEmbed, 1),
      isEmbed = _useIsEmbed2[0];

  return /*#__PURE__*/_jsxs(Flex, {
    direction: "column",
    p: ['1.5rem'],
    justify: "start",
    align: "center",
    w: "100%",
    h: "auto",
    minH: isEmbed && '100vh',
    alignSelf: "center",
    maxWidth: isEmbed ? 'none' : 'lg',
    bg: "white",
    children: [children, /*#__PURE__*/_jsx(Box, {
      mt: "8",
      mb: "2",
      children: /*#__PURE__*/_jsx(PoweredByLogo, {})
    })]
  });
};